/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Searchplaceholder2Inputs */

const zh_adminsubs_searchplaceholder2 = /** @type {(inputs: Adminsubs_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索用户名、邮箱或计划...`)
};

const en_adminsubs_searchplaceholder2 = /** @type {(inputs: Adminsubs_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search username, email, or plan...`)
};

const es_adminsubs_searchplaceholder2 = /** @type {(inputs: Adminsubs_Searchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar usuario, correo o plan...`)
};

/**
* | output |
* | --- |
* | "Search username, email, or plan..." |
*
* @param {Adminsubs_Searchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_searchplaceholder2 = /** @type {((inputs?: Adminsubs_Searchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Searchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_searchplaceholder2(inputs)
	if (locale === "en") return en_adminsubs_searchplaceholder2(inputs)
	return es_adminsubs_searchplaceholder2(inputs)
});
export { adminsubs_searchplaceholder2 as "adminSubs_searchPlaceholder" }